import React, { useEffect } from 'react';
import { ethers } from 'ethers';
import { useNetwork } from './NetworkContext';
import { useNavigate } from 'react-router-dom';
import '../ConnectButtons.css';


const ConnectButtons = () => {
    const { setNetwork, setWalletAddress, network } = useNetwork();
    const navigate = useNavigate();


    const connectToNetwork = async (networkName, chainId, chainName, rpcUrls, nativeCurrency, blockExplorerUrls) => {
        if (window.ethereum) {
            try {
                await window.ethereum.request({ method: 'eth_requestAccounts' });
                await window.ethereum.request({
                    method: 'wallet_addEthereumChain',
                    params: [{
                        chainId: chainId,
                        chainName: chainName,
                        rpcUrls: rpcUrls,
                        nativeCurrency: nativeCurrency,
                        blockExplorerUrls: blockExplorerUrls,
                    }],
                });
                const provider = new ethers.BrowserProvider(window.ethereum);
                const signer = await provider.getSigner();
                const accounts = signer.address;
                setWalletAddress(accounts);
                setNetwork(networkName);
                // navigate('/home');
            } catch (error) {
                console.error(`Failed to connect to ${networkName}:`, error);
            }
        } else {
            alert('MetaMask is not installed');
        }
    };

    const connectAvalanche = () => {
        connectToNetwork(
            'avalanche',
            "0xA869",
            'Avalanche Fuji C-Chain',
            ['https://api.avax-test.network/ext/bc/C/rpc'],
            { name: 'AVAX', symbol: 'AVAX', decimals: 18 },
            ['https://cchain.explorer.avax-test.network']
        );
    };

    const connectPolygon = () => {
        connectToNetwork(
            'polygon',
            "0x13882",
            'Polygon Amoy',
            ['https://rpc-amoy.polygon.technology/'],
            { name: 'MATIC', symbol: 'MATIC', decimals: 18 },
            ['https://www.oklink.com/amoy']
        );
    };

    return (
        <div className="connect-buttons-container">
            <button onClick={connectAvalanche}>Connect to Avalanche Fuji</button>
            <button onClick={connectPolygon}>Connect to Polygon Amoy</button>
        </div>
    );
};

export default ConnectButtons;
